<template>
    <div class="loading-container">
        <div v-if="show" class="loader">
            <md-progress-spinner class="loader" :md-diameter="diametro" :md-stroke="espessura" md-mode="indeterminate"></md-progress-spinner>
        </div>

        <slot v-else />
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            show: Boolean,
            diametro: Number,
            espessura: Number,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .loading-container {
        height: 100%;
    }

        .loading-container > .loader {
            height: 100%;
            display: -webkit-flexbox;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-flex-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            justify-content: center;
        }
</style>
